module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/sec02_2_pc_80d120832b9b229de96515c88890a047.png";